import { createAction } from '@reduxjs/toolkit';

const adjustmentCreatedSuccess = createAction('adjustment/create/success');
const adjustmentCreatedFailure = createAction('adjustment/create/failure');

export { adjustmentCreatedSuccess, adjustmentCreatedFailure };
